export default __webpack_public_path__ + "static/office4-1x-efe755b471ce235767e28e93f7aa1bc1.jpg";